import React, { useContext } from 'react';
import {
	IStyleSettingsCarouselUploaderContext,
	StyleSettingsCarouselUploaderContext,
} from '../styleSettingsCarouselUploaderState/styleSettingsCarouselUploaderContext';
import { ModalWrapper } from 'components/ModalWindows/ModalWrapper';
import { ModalSentErrorNew } from 'components/ModalWindows/ModalSentErrorNew';

interface IProps {
	imageMaxFileSizeMB: number;
	videoMaxFileSizeMB: number;
	pdfMaxFileSizeMB: number;
}

export const ErrorModalsNew: React.FC<IProps> = ({ imageMaxFileSizeMB, videoMaxFileSizeMB, pdfMaxFileSizeMB }) => {
	const { changeTypeOfErrorModalWindow, typeOfErrorModalWindow } = useContext<IStyleSettingsCarouselUploaderContext>(
		StyleSettingsCarouselUploaderContext,
	);

	const handleCloseModal = () => {
		changeTypeOfErrorModalWindow(null);
	};

	return (
		<ModalWrapper isVisible={!!typeOfErrorModalWindow}>
			{typeOfErrorModalWindow === 'imageFileSizeExceeded' && (
				<ModalSentErrorNew
					onConsentEvent={handleCloseModal}
					description="fileSizeExceeded"
					translationOptions={{ size: `${imageMaxFileSizeMB}MB` }}
				/>
			)}
			{typeOfErrorModalWindow === 'videoFileSizeExceeded' && (
				<ModalSentErrorNew
					onConsentEvent={handleCloseModal}
					description="fileSizeExceeded"
					translationOptions={{ size: `${videoMaxFileSizeMB}MB` }}
				/>
			)}
			{typeOfErrorModalWindow === 'pdfFileSizeExceeded' && (
				<ModalSentErrorNew
					onConsentEvent={handleCloseModal}
					description="fileSizeExceeded"
					translationOptions={{ size: `${pdfMaxFileSizeMB}MB` }}
				/>
			)}
			{typeOfErrorModalWindow === 'fileUploadError' && (
				<ModalSentErrorNew onConsentEvent={handleCloseModal} description="fileUploadError" />
			)}
			{typeOfErrorModalWindow === 'fileDownloadError' && (
				<ModalSentErrorNew onConsentEvent={handleCloseModal} description="fileDownloadError" />
			)}
			{typeOfErrorModalWindow === 'invalidFileFormat' && (
				<ModalSentErrorNew
					onConsentEvent={handleCloseModal}
					description="invalidFileFormatPhotoVideo"
					translationOptions={{ photoFormats: '.jpeg, .jpg, .png', videoFormats: '.mp4' }}
				/>
			)}
			{typeOfErrorModalWindow === 'invalidPdfFormat' && (
				<ModalSentErrorNew
					onConsentEvent={handleCloseModal}
					description="invalidFileFormat"
					translationOptions={{ format: '.pdf' }}
				/>
			)}
		</ModalWrapper>
	);
};
